import * as types from './actionsTypes'
import { pendingSize } from './utils'

const initialState = {
  pendingTypes: [],
  list: [],
  page: 1,
  hasMore: false,
  indicators: {},
  countOfUpdate: 0,
  pendingModal: {
    visible: false,
    type: undefined,
  },
  selectedPending: null,
  isApplicationLoading: false
}

const pendings = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_ALL_PENDINGS:
      return {
        ...state,
        list:
          payload.page === 1 ? payload.data : [...state.list, ...payload.data],
        hasMore: payload.data.length >= pendingSize,
        page: payload.page,
        countOfUpdate: payload.page === 1 ? 0 : state.countOfUpdate,
      }

    case types.SET_PENDING_MODAL_VISIBLE:
      return {
        ...state,
        pendingModal: {
          ...state.pendingModal,
          ...payload,
        },
      }
    case types.GET_ALL_PENDING_TYPES:
      return {
        ...state,
        pendingTypes: payload || []
      }

    case types.FETCH_PENDING_INDICATORS:
      return {
        ...state,
        indicators: { ...payload },
      }
    case types.INCREMENT_COUNT_OF_UPDATE:
      return {
        ...state,
        countOfUpdate: state.countOfUpdate + 1,
      }
    case types.GET_PENDING_BY_ID:
      return {
        ...state,
        selectedPending: payload
      }
    case types.PENDING_IS_APPLICATION_LOADING:
      return {
        ...state,
        isApplicationLoading: payload
      }
    default:
      return state
  }
}
export default pendings
